// Pemuat skrip Midtrans Snap (tanpa dependency lain agar mudah diuji unit).
// URL mengikuti mode key: sandbox utk Testing, produksi utk live.
let snapLoading = null;

export function loadSnap(clientKey, isProd) {
  if (window.snap) return Promise.resolve();
  if (snapLoading) return snapLoading;
  snapLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = isProd ? "https://app.midtrans.com/snap/snap.js" : "https://app.sandbox.midtrans.com/snap/snap.js";
    s.setAttribute("data-client-key", clientKey || "");
    s.async = true;
    s.onload = () => { snapLoading = null; resolve(); };
    s.onerror = () => { snapLoading = null; s.remove(); reject(new Error("snap load failed")); };
    document.body.appendChild(s);
  });
  return snapLoading;
}
